import React, { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { TenantLogo } from "@/pages/PlatformPage";
import { ImagePlus } from "lucide-react";
import { toast } from "sonner";

export const CompanyCard = () => {
  const { refresh } = useAuth();
  const [t, setT] = useState(null);
  const ref = useRef(null);
  useEffect(() => { api.get("/tenant").then(({ data }) => setT(data)); }, []);
  if (!t) return null;

  const save = async () => {
    try {
      const { data } = await api.put("/tenant", { name: t.name, segment: t.segment || "", description: t.description || "" });
      setT(data); toast.success("Dados da empresa salvos"); refresh();
    } catch (e) { toast.error(Array.isArray(e.response?.data?.detail) ? "Nome inválido" : e.response?.data?.detail || "Falha ao salvar"); }
  };
  const upload = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    try { const { data } = await api.post("/tenant/logo", fd); setT({ ...t, logo_url: data.logo_url }); toast.success("Logo atualizada"); refresh(); }
    catch (e) { toast.error(e.response?.data?.detail || "Falha ao enviar logo"); }
  };

  return (
    <Card data-testid="company-card">
      <CardContent className="p-5 space-y-3">
        <div className="flex items-center gap-4">
          <TenantLogo tenant={t} className="w-14 h-14" />
          <Button size="sm" variant="outline" onClick={() => ref.current?.click()} data-testid="company-logo-button"><ImagePlus className="w-4 h-4 mr-1" /> Trocar logo</Button>
          <input ref={ref} type="file" accept="image/*" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid="company-logo-input" />
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          <div><Label>Nome da empresa</Label><Input value={t.name} onChange={(e) => setT({ ...t, name: e.target.value })} className="mt-1" data-testid="company-name-input" /></div>
          <div><Label>Segmento / atividade</Label><Input value={t.segment || ""} onChange={(e) => setT({ ...t, segment: e.target.value })} className="mt-1" data-testid="company-segment-input" /></div>
        </div>
        <div>
          <Label>Sobre a empresa (a IA usa para responder clientes)</Label>
          <Textarea value={t.description || ""} onChange={(e) => setT({ ...t, description: e.target.value })} rows={3} className="mt-1"
                    placeholder="Produtos/serviços, horários, regiões atendidas, formas de pagamento…" data-testid="company-description-input" />
        </div>
        <Button size="sm" onClick={save} className="bg-emerald-600 hover:bg-emerald-700" data-testid="company-save-button">Salvar dados da empresa</Button>
      </CardContent>
    </Card>
  );
};
